import type { JSONContent } from '@tiptap/core'
import z from 'zod'

export type { JSONContent as TiptapContent }

export const tiptapContentSchema = z
  .record(z.string(), z.unknown())
  .transform(v => v as JSONContent)

export const getTiptapContentTextLength = (content: JSONContent | null): number => {
  // Backend validation can receive hand-crafted JSON, so avoid recursive traversal that could
  // overflow the call stack on a deeply nested payload.
  let nodes = content ? [content] : []
  let length = 0

  while (nodes.length > 0) {
    length += nodes.reduce(
      (sum, node) => sum + (typeof node.text === 'string' ? node.text.length : 0),
      0
    )
    nodes = nodes.flatMap(node => (Array.isArray(node.content) ? node.content : []))
  }

  return length
}
